<template>
    <component :is="as == 'q' ? 'q' : 'p'" v-bind="props ?? {}">
        {{ isTruncated ? truncate(content, { length: max ?? 180 }) : content }}

        <span v-if="content.length > (max ?? 180)"><br /><span class="primary-text"
                :style="{ cursor: 'pointer', fontSize: '10px' }" @click=" isTruncated = !isTruncated">{{ isTruncated ?
                    'read more' : 'hide' }}</span></span>
    </component>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import truncate from 'lodash/truncate'


defineProps<{
    max?: number;
    content: string;
    as?: 'p' | 'q';
    props?: Record<string, any>
}>()


const isTruncated = ref(true)
</script>
